<template>
  <TabGroup>
    <TabList class="flex justify-center rounded-xl bg-blue-900/20 p-1">
      <Tab as="template" v-slot="{ selected }" class="w- full leading-5">
        <button
          :class="[
            'p-3 rounded',
            selected &&
              ' text-primary-400 ring-black/60  focus:outline-none  border border-gray-700 ',
            ,
            !selected && ' text-black ring-black/60  focus:outline-none  ',
            ,
          ]"
        >
          Thêm sản phẩm
        </button>
      </Tab>
      <!-- <Tab as="template" v-slot="{ selected }" class="w- full leading-5">
        <button :class="[
          'rounded p-3',
          selected &&
          ' text-primary-400 ring-black/60  focus:outline-none  border border-gray-700 ',
          ,
          !selected && ' text-black ring-black/60  focus:outline-none ',
          ,
        ]">
          Thêm multi hình phụ sản phẩm
        </button>
      </Tab> -->
    </TabList>
    <TabPanels>
      <TabPanel class="p-3">
        <form
          id="Frmadd"
          enctype="multipart/form-data"
          :action="route('product.add')"
          method="post"
        >
          <FormProduct :title="title" :categories="categories">
            <slot></slot>
          </FormProduct>
        </form>
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>

<script setup>
import { defineProps, ref } from 'vue'
import MultiImages from './MultiImages.vue'
import route from 'ziggy-js'
import FormProduct from './FormProduct.vue'
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue'

const props = defineProps(['title', 'categories'])
</script>
